<template>
  <div id="compreSportsMeet_scheduleDetail_dataBattleReport">
    <NOT_DATA
      :className="'relativePtb30'"
      v-if="dataBattleReportInfor && !dataBattleReportInfor.isHasData"
    />
    <template
      v-if="
        dataBattleReportInfor &&
        dataBattleReportInfor.isHasData &&
        dataBattleReportInfor.dataArr
      "
    >
      <div class="dataBattleReport_infor">
        <p
          v-for="(textItem, textIndex) in dataBattleReportInfor.dataArr"
          :key="textIndex"
          class="textItem"
          v-text="textItem"
        ></p>
      </div>
    </template>
  </div>
</template>

<script>
// 数据战报
import cup_base_data_mixin from '@mixins/cup_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
export default {
  name: 'compreSportsMeet_scheduleDetail_dataBattleReport',
  mixins: [cup_base_data_mixin],
  components: { NOT_DATA },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    dataBattleReportInfor: {
      type: [Object, null],
      default: null, // isHasData:true有数据，false无数据
    },
    // isRefresh: {
    //   type: Boolean,
    //   default: false,
    // },
    // refreshTime: {
    //   type: Number,
    //   default: 15 * 1000, //刷新时间 单位毫秒
    // },
  },
  //   watch: {
  //     currSportsDetail: {
  //       handler(newVal, oldVal) {
  //         console.debug('重新刷新数据 currSportsDetail:', newVal, oldVal)
  //         if (
  //           JSON.stringify(newVal) != JSON.stringify(oldVal) &&
  //           newVal.matchId
  //         ) {
  //           this.init()
  //         }
  //       },
  //       // immediate: true,
  //       deep: true,
  //     },
  //   },
  data() {
    return {
      // 以下三个是主题固定参数（前2个必有，paramsChangeObj可选）
    }
  },
  created() {
    if (this.currSportsDetail && this.currSportsDetail.matchId) {
      this.init()
    } else {
    }
  },
  mounted() {},
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      const query = this.$route.query
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_scheduleDetail_dataBattleReport {
  padding: 1.388vw 0;
  width: 100%;
  height: auto;
  .dataBattleReport_infor {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    padding: 1.388vw 1.11vw;
    .textItem {
      width: 100%;
      padding-bottom: 1.11vw;
      font-size: 1.11vw;
      line-height: 1.68vw;
      text-align: justify;
      text-indent: 2.22vw;
      color: var(--mixtmt_greyColor2);
    }
  }
}

</style>
